import { render, staticRenderFns } from "./DiagnosisSummary.vue?vue&type=template&id=711ef4e9&"
import script from "./DiagnosisSummary.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711ef4e9')) {
      api.createRecord('711ef4e9', component.options)
    } else {
      api.reload('711ef4e9', component.options)
    }
    module.hot.accept("./DiagnosisSummary.vue?vue&type=template&id=711ef4e9&", function () {
      api.rerender('711ef4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/DiagnosisSummary.vue"
export default component.exports